import { createApp } from 'vue'
import App from './App.vue'
import bootstrap from 'bootstrap';
import router from './router'
// import { ModalPlugin } from 'bootstrap'
// import VueMoment from 'vue-moment'
import './assets/style.css'



const app = createApp(App)
app.use(router)
// app.use(VueMoment)
app.mount('#app')
// app.use(ModalPlugin)
